import * as React from 'react';
import { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { area, textSet } from './constants';
import { textCollectionActionCreators } from 'app/infrastructure/translate/actions';
import { useSharedState } from 'app/infrastructure/redux/hooks';

export const withTexts = 
  (textMappings: Record<string, number>) => 
  <C extends React.ComponentType<any>>(Component: C) => {
  type Props = React.ComponentPropsWithoutRef<C>;
  type Ref = React.ComponentRef<C>;

  const WrappedComponent = Component as React.ComponentType<Props & React.RefAttributes<Ref>>;

  return React.forwardRef<Ref, Props>((props, ref)  => {
  
  const dispatch: Dispatch<any> = useDispatch();
  const sharedState = useSharedState();
  const language = sharedState?.language?.value;

  useEffect(() => {
    if (language) {
      dispatch(textCollectionActionCreators.loadTextCollection([area], language));
    }
  }, [dispatch, language]);
  
  const textState = useSelector(state => state[area]?.texts?.texts);

  const textProps = Object.keys(textMappings).reduce((aggr, t) => {
    const id = textMappings[t];
    const textFromState = textState?.find(c => c.id.textSet === textSet && c.id.no === id);
    if (textFromState) {
      aggr[t as keyof Props] = textFromState.description as Props[keyof Props];
    }
    return aggr;
  }, {} as Partial<Props>);
  
  return <WrappedComponent
    {...({ ...textProps, ...props } as Props)}
    ref={ref}
  />;
  });
};
